import React from 'react';

import Modal from '../../shared/modals/modal.component';
import { FieldError } from '../../shared/types';

type ValidationErrors = {
  [rowIndex: string]: {
    [field: string]: FieldError[]
  },
}

const HEADER_ROWS_COUNT = 1;
const EXCEL_NUMBERING_START = 1;

const ImportBeginningBalanacesValidationModal = ({
  data,
  isVisible,
  hideImportBeginningBalancesValidationModal,
}: {
  data: {
    validationErrors: ValidationErrors
  },
  isVisible: boolean,
  hideImportBeginningBalancesValidationModal: () => void,
}) => {
  const formatRowError = (error: ValidationErrors[string]) => Object.values(error).flatMap(value => value.map(({ message }) => message)).join(', ');
  const messages = data && data.validationErrors
    ? Object.entries(data.validationErrors).map(([rowIndex, rowError]) => [rowIndex, formatRowError(rowError)])
    : null;

  return (
    <Modal
      className="import-beginning-balances-validation-modal"
      title="Cannot import balance file"
      closeAction={hideImportBeginningBalancesValidationModal}
      dismissText="Close"
      dismissAction={hideImportBeginningBalancesValidationModal}
      isVisible={isVisible}
    >
      <ul>
        {messages ? messages.map(([rowIndex, message]) =>
          <li key={rowIndex}>
            {`Row ${Number(rowIndex) + EXCEL_NUMBERING_START + HEADER_ROWS_COUNT} in imported file has following errors: `}<b>{message}</b>
          </li>
        ) : null}
      </ul>
    </Modal>
  );
};

export default ImportBeginningBalanacesValidationModal;
